import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import type { TourDocumentView } from 'entities/tour/models/document'

import { Button } from 'shared/ui/button'

import common from '../../styles.module.scss'

import s from './styles.module.scss'

interface Props {
  isPaymentExpired: boolean
  onOpenHistory: () => void
  document: TourDocumentView
}

export const PaymentCard: FC<Props> = ({
  document,
  isPaymentExpired,
  onOpenHistory,
}) => {
  const { t } = useTranslation()
  const paymentLabel = isPaymentExpired
    ? t('tourDetails.paymentExpired')
    : document.paymentStatus === 'PAID'
      ? t('tourDetails.paid')
      : document.paymentStatus === 'PARTIALLY_PAID'
        ? t('tourDetails.partiallyPaid')
        : document.paymentStatus === 'UNPAID'
          ? t('tourDetails.unpaid')
          : null

  if (
    document.amount === null &&
    document.remainingAmount === null &&
    document.paymentStatus === null &&
    !document.payments.length
  ) {
    return null
  }

  return (
    <section className={common.card}>
      <div className={clsx(common.row, s.row)}>
        <div>
          <h2 className="bold-16">{t('tourDetails.price')}</h2>
          {paymentLabel && (
            <p
              className={clsx(
                common.caption,
                isPaymentExpired && s.expired,
                'regular-14',
              )}
            >
              {paymentLabel}
            </p>
          )}
        </div>
        {document.amount !== null && (
          <p className={clsx(s.price, 'bold-16')}>
            {document.amount.toLocaleString('ru-RU')}
            <u>с</u>
          </p>
        )}
      </div>
      <Button
        variant="transparent"
        className={clsx(common.link, 'medium-14')}
        onClick={onOpenHistory}
      >
        {t('tourDetails.payments')}
      </Button>
    </section>
  )
}
